export default {
  user: 'runelite',
  repository: 'runelite'
}
